import { CartItem } from 'lib/core/data/quote/cart/types'
import { MagentoCartItemInterface as CartItemInterface } from 'lib/types'

export interface CustomCartItem extends CartItem {
  frequencyInCart?: string
  packageQty?: string
  associatedPromoHash?: string
  associatedProduct?: CustomCartItem
  promoQty?: number
}

export const cartItems = {
  processor: (cartItem: CustomCartItem, data: CartItemInterface) => {
    cartItem.prices = data.prices
    // @ts-expect-error
    cartItem.frequencyInCart = data.frequency_in_cart
    // @ts-expect-error
    cartItem.promoQty = data.promo_qty
    // @ts-expect-error
    cartItem.packageQty = data.package_qty
    // @ts-expect-error
    cartItem.associatedPromoHash = data.associated_promo_hash
  }
}
